import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './single_note.scss';

const SingleNote = props => (
  <div className="note-wrapper">
    <div className="note">
      <div className="note-content">
        <p>
          {props.note.note &&
            props.note.note.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
        </p>
      </div>
      {!props.withoutDescription && (
        <div className="note-meta">
          <p className="subtext">
            by {props.note.author}
            {props.note.created_at && (
              <span>
                • <em>{moment.utc(props.note.created_at).fromNow()}</em>
              </span>
            )}
          </p>
        </div>
      )}
    </div>
  </div>
);

SingleNote.propTypes = {
  note: PropTypes.shape({
    note: PropTypes.string,
    author: PropTypes.string,
    created_at: PropTypes.string,
  }),
  withoutDescription: PropTypes.bool,
};

export default SingleNote;
